import {
    Drawer,
    Input,
    Col,
    Select,
    Form,
    Button,
    Row,
    Spin
} from 'antd';
import { LoadingOutlined } from "@ant-design/icons";
import { useEffect, useLayoutEffect, useState } from 'react';
import { createUsers, fetchRoles, updateUser } from '@/apiCalls/apiCalls';
import { errorNotification, successNotification } from '@/utils/Notification';
import { Users } from './UsersColumns';
import { useLocation, useNavigate } from 'react-router-dom';
import useAxiosPrivate from '@/context/UseAxiosPrivate';
import { Roles } from '../roles/RolesColumns';
import SpinnerForm from '../spinnner/SpinnerForm';
import axios from 'axios';
import { User } from 'lucide-react';
const { Option } = Select;

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />
interface ProductsDrawerProps {
    showchangePasswordDrawer: boolean;
    setchangePasswordDrawer: React.Dispatch<React.SetStateAction<boolean>>;
    Users: Users
    getUsers: any
    setUserData: React.Dispatch<React.SetStateAction<Users | undefined>>;
}
const ChangePasswordDrawer: React.FC<ProductsDrawerProps> = ({ showchangePasswordDrawer, setchangePasswordDrawer, Users, getUsers, setUserData }) => {
    const onCLose = () => {
        setUserData(undefined)
        setchangePasswordDrawer(false)
    }
    const [submitting, setSubmitting] = useState(false)
    const [loadingForm, setLoadingForm] = useState(true)
    const [form] = Form.useForm()
    const navigate = useNavigate();
    const location = useLocation();
    const axiosPrivate = useAxiosPrivate()

    useLayoutEffect(() => {
        const setFormValues = async () => {

            form.setFieldsValue({
                id: Users.id,
                // password: Users.password
            })
            setLoadingForm(false)
        };
        if (Users) {
            setFormValues()
        }
    }, [Users, form])













    const getClientIPAndURL = async () => {
        try {
            const response = await axios.get('https://api.ipify.org?format=json');
            const clientIp = response.data.ip
            const currentUrl = window.location.href
            return { clientIp, currentUrl }
        } catch (error) {
            console.error('Error fetching IP address:', error);
            return { clientIp: 'Unknown', currentUrl: window.location.href }
        }
    }

    const onFinish = (payload: any) => {
        setSubmitting(true)
        let isMounted = true;
        const controller = new AbortController()
        getClientIPAndURL().then(({ clientIp, currentUrl }) => {
            return axiosPrivate.put(`/api/v1/users/changepassword/${payload.id}`, payload, {
                signal: controller.signal,
                headers: {
                    'X-Client-IP': clientIp,
                    'X-Origin-URL': currentUrl
                }
            })
        }).then(() => {
            if (isMounted) {
                onCLose()
                successNotification(
                    "password successfully updated",
                    `${Users.email} was updated`,
                    'topRight'
                )
            }
            getUsers()
        }).catch((err: any) => {
            const errors = err?.response?.data?.errors;
            if (errors && errors?.[0]?.message === "token as expired") {
                let errror = errors?.[0]?.message
                errorNotification(
                    "There was an issue",
                    `${errror}`,
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            } else if (errors && Array.isArray(errors) && errors.length > 0) {
                errors.forEach((error: any) => {
                    const errorMessage = error.message || "An unknown error occurred";
                    errorNotification(
                        "There was an issue",
                        `${errorMessage}`,
                        'topRight'
                    );
                });
            } else {
                errorNotification(
                    "There was an issue",
                    "No server reponse",
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            }
        }).finally(() => {
            setSubmitting(false)
        })
        return () => {
            isMounted = false;
            controller.abort();
        };
    };


    const onFinishFailed = (errorInfo: any) => {
        alert(JSON.stringify(errorInfo, null, 2));
    }

    return (
        <>
            <Drawer
                title={`change password for ${Users.user_name} `}
                width={720}
                onClose={onCLose}
                open={showchangePasswordDrawer}
                bodyStyle={{ paddingBottom: 80 }}
                style={{
                    backgroundColor: 'white',
                    transition: 'transform 0.3s ease, opacity 0.3s ease'
                }}
                maskStyle={{
                    transition: 'opacity 0.3s ease'
                }}
                footer={
                    <div
                        style={{
                            textAlign: 'right',
                        }}
                    >
                        <Button onClick={onCLose} style={{ marginRight: 8 }}>
                            Cancel
                        </Button>
                    </div>
                }
            >

                {loadingForm ? (
                    <div>
                        <SpinnerForm />
                    </div>
                ) : (
                    <Form layout="vertical"
                        onFinishFailed={onFinishFailed}
                        onFinish={onFinish}
                        form={form}
                        initialValues={{
                            id: Users.id,
                            // password: Users.password
                        }}
                        hideRequiredMark>
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item
                                    name="password"
                                    label="password"
                                    rules={[{ required: true, message: 'Please enter name' }]}
                                >
                                    <Input
                                        placeholder="Please enter name"
                                        className='focus:border-green-500 hover:border-green-500'
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    name="id"
                                    label="id"
                                    hidden={true}
                                    rules={[{ required: true, message: 'Please enter password' }]}
                                >
                                    <Input
                                        placeholder="Please enter password"
                                        className='focus:border-green-500 hover:border-green-500'
                                    />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row>
                            <Col span={12}>
                                <Form.Item>
                                    <Button type="primary" htmlType="submit" style={{ backgroundColor: 'green' }}>
                                        Submit
                                    </Button>
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row>

                            {submitting && <Spin indicator={antIcon} />}
                        </Row>


                    </Form>
                )}

            </Drawer>
        </>
    )
}

export default ChangePasswordDrawer;


